/* eslint-disable @typescript-eslint/naming-convention */
import _ from 'lodash';
import React, { useCallback, useContext } from 'react';
import { withRouter } from 'react-router';
import { AsyncComponent } from '../../../components/AsyncComponent';
import { DotsContentMenu } from '../../../components/ContentMenu/DotsContentMenu';
import { EvenlySpacedItemsList } from '../../../components/EvenlySpacedItemsList';
import { ContentType } from '../../../enums/ContentType';
// TODO: reativar quando a MrTuring tiver cobertura completa de resumos
// import { AISummaryButton } from '../../../features/ai_summary';
import { BookContextModel } from '../../../models/book/BookContextModel';
import { BookEditionChapterModel } from '../../../models/book/BookEditionChapterModel';
import { BookEditionModel } from '../../../models/book/BookEditionModel';
import { ContentSearchResult } from '../../../models/ContentSearchResult';
import { ArticleListItem } from '../../periodico/components/ArticleListItem';
import { BookContext } from './BookContextProvider';
import { Icon } from 'antd';

interface IProps {
  selectedChapterId?: number;
  match?: any;
  history?: any;
  book: BookEditionModel;
  editionId: number;
  currentEdition?: any;
}

const _BookEditionChapterList = ({
  selectedChapterId,
  match,
  history,
  book,
  currentEdition
}: IProps) => {
  const { bookId, editionId } = match.params;
  const ctx = useContext<{ state: BookContextModel }>(BookContext as any);
  const { editionChaptersRequest } = ctx.state;

  const createChapterLink = useCallback(
    (chapterId: any) =>
      `/v2/livro/${bookId || book.id}/${editionId}/${chapterId}`,
    [book, bookId, editionId]
  );

  const createContentSearchResultFromChapter = useCallback(
    (chapter: BookEditionChapterModel) => {
      if (!book) return ContentSearchResult.Empty;
      const stage = process.env.REACT_APP_STAGE || 'staging';
      const imageSrc = `https://bid1006-${stage}-public.s3.sa-east-1.amazonaws.com${book.image}`;
      return new ContentSearchResult(
        ContentType.CHAPTER,
        chapter.id,
        chapter.title,
        book.title,
        book.description,
        null,
        editionId,
        bookId,
        imageSrc,
        chapter.author,
        null,
        `Atualizado em: ${book.year}`,
        null,
        null,
        book.areasInterest,
        undefined,
        String(chapter.id)
      );
    },
    [book]
  );

  return (
    <AsyncComponent
      error={
        editionChaptersRequest.error &&
        _.get(editionChaptersRequest.error, 'response.status') === 500
      }
      loading={editionChaptersRequest.loading}
      renderContent={() => {
        if (!editionChaptersRequest.result) return null;

        const groupedChaptersBySubtitle = _.groupBy(
          editionChaptersRequest.result,
          'subtitle'
        );

        const printSubtitles = [
          { subtitle: 'Pré textual', label: 'Pré-Textual' },
          { subtitle: 'Capítulos', label: 'Capítulos' },
          { subtitle: 'Pós textual', label: 'Pós-Textual' }
        ];

        return ['Pré textual', 'Capítulos', 'Pós textual'].map((subtitle) => {
          const chapters = groupedChaptersBySubtitle[subtitle];

          if (!chapters) {
            console.warn('lista de capitulos vazia');
            return null;
          }

          // TODO: reativar com AISummaryButton quando a MrTuring tiver cobertura completa
          // const isMainChapters = subtitle === 'Capítulos';

          return (
            <div key={subtitle}>
              <h3 style={{ marginTop: '1rem' }}>
                {printSubtitles.find((p) => p.subtitle === subtitle).label ||
                  subtitle}
              </h3>
              <EvenlySpacedItemsList>
                {chapters.map(
                  (chapter: BookEditionChapterModel, index: number) => (
                    <ArticleListItem
                      key={`${chapter.id}-${index}`}
                      article={chapter}
                      link={createChapterLink(chapter.id)}
                      active={selectedChapterId === chapter.id}
                      onClick={() => {
                        history.push(createChapterLink(chapter.id));
                      }}
                      Menu={
                        currentEdition && currentEdition.onlyView ? (
                          <Icon type="lock" style={{ fontSize: 30 }} />
                        ) : (
                          // TODO: reativar AISummaryButton quando a MrTuring tiver cobertura completa de resumos
                          // <div
                          //   style={{
                          //     display: 'flex',
                          //     alignItems: 'center',
                          //     gap: '0.5rem'
                          //   }}>
                          //   {isMainChapters && (
                          //     <AISummaryButton
                          //       source={{
                          //         kind: 'book',
                          //         bookId: bookId || book.id,
                          //         editionId,
                          //         chapterId: chapter.id
                          //       }}
                          //       variant="compact"
                          //     />
                          //   )}
                          //   <DotsContentMenu ... />
                          // </div>
                          <DotsContentMenu
                            result={createContentSearchResultFromChapter(
                              chapter
                            )}
                          />
                        )
                      }
                    />
                  )
                )}
              </EvenlySpacedItemsList>
            </div>
          );
        });
      }}
    />
  );
};

//@ts-ignore
export const BookEditionChapterList = withRouter(_BookEditionChapterList);
